import React from 'react';

import {
  LoginRoute,
  LogoutRoute,
  RootRoute,
  BaseRoute,
  OauthDelegateRoute,
  OauthLoginCallback,
  OauthAttachCallback,
  DmmLoginCallback,
  IncompleteProfileRoute,
} from 'app/constants/Routes';

import WrongBrandRedirect from 'app/components/auth/WrongBrandRedirect';
import IncompleteProfileRedirect from 'app/components/auth/IncompleteProfileRedirect';
import DmmLoginRedirect from 'app/components/auth/DmmLoginRedirect';
import { ConditionalExclude } from 'app/components/router/ConditionalRedirect';
import { LoginIntent } from 'app/services/oauth/constants';

const BASE_EXCLUDE_ROUTES = [
  LoginRoute,
  LogoutRoute,
  RootRoute,
  BaseRoute,
];

const OAUTH_EXCLUDE_ROUTES = [
  OauthDelegateRoute,
  OauthLoginCallback,
  OauthAttachCallback,
  DmmLoginCallback,
];

const WRONG_BRAND_EXCLUDE_ROUTES = [
  IncompleteProfileRoute,
  ...BASE_EXCLUDE_ROUTES,
  ...OAUTH_EXCLUDE_ROUTES,
];

const DMM_LOGIN_EXCLUDE_ROUTES = [
  ...BASE_EXCLUDE_ROUTES,
  ...OAUTH_EXCLUDE_ROUTES,
];

const INCOMPLETE_PROFILE_EXCLUDE_ROUTES = [
  LogoutRoute,
  OauthLoginCallback,
  new ConditionalExclude({
    routes: [OauthDelegateRoute],
    whenQueryKey: ['force_login'],
    unlessQueryKey: ['honoredIntent'],
    whenQueryValue: [{ intent: LoginIntent.Register }],
  }),
];

interface IProps {
  children: React.ReactNode;
}

/*
 * The more inner the component the earlier the redirect is calculated.
 * WrongBrandRedirect therefore happens before IncompleteProfileRedirect.
 *
 * Furthermore, the WrongBrandRedirect is also given the incomplete profile page
 * as an additional page to ignore. If more redirects are added, this component
 * should be used to string together the redirects to respect each other's boundaries.
 *
 * The DmmLoginRedirect will go to the LoginRoute which is ignored by both the
 * IncompleteProfileRedirect and WrongBrandRedirects so no additional
 * excludeRoutes are needed.
 */
export const SiteWideRedirectMiddleware: React.SFC<IProps> = ({ children }) => (
  <IncompleteProfileRedirect excludeRoutes={INCOMPLETE_PROFILE_EXCLUDE_ROUTES}>
    <WrongBrandRedirect excludeRoutes={WRONG_BRAND_EXCLUDE_ROUTES}>
      <DmmLoginRedirect excludeRoutes={DMM_LOGIN_EXCLUDE_ROUTES}>
        {children}
      </DmmLoginRedirect>
    </WrongBrandRedirect>
  </IncompleteProfileRedirect>
);

export default SiteWideRedirectMiddleware;
